import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, x = 0, y = 24, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y, x }}
    whileInView={{ opacity: 1, y: 0, x: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, dark = false }) => (
  <Reveal className="max-w-2xl">
    <p className={`eyebrow mb-3 ${dark ? "!text-gold" : ""}`} data-testid="section-eyebrow">
      {eyebrow}
    </p>
    <h2
      className={`font-display text-3xl font-semibold leading-tight sm:text-5xl ${
        dark ? "text-cream" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-cream/70" : "text-soft"}`}>
        {sub}
      </p>
    )}
  </Reveal>
);
